let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7JjmO")).then(() => parcelRequire('1xi4I'));